var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90237 0.569037C2.03255 0.438861 2.03255 0.227807 1.90237 0.0976301C1.7722 -0.0325434 1.56114 -0.0325434 1.43097 0.0976301L0.0976301 1.43097C-0.0325434 1.56114 -0.0325434 1.7722 0.0976301 1.90237L1.43097 3.2357C1.56114 3.36587 1.7722 3.36587 1.90237 3.2357C2.03255 3.10554 2.03255 2.89447 1.90237 2.7643L1.13807 2H4.33334C4.51744 2 4.66667 1.85076 4.66667 1.66667C4.66667 1.48258 4.51744 1.33334 4.33334 1.33334H1.13807L1.90237 0.569037ZM5.90237 4.09764L4.56904 2.7643C4.43887 2.63414 4.22781 2.63414 4.09764 2.7643C3.96747 2.89447 3.96747 3.10554 4.09764 3.2357L4.86194 4.00001H1.66667C1.48258 4.00001 1.33334 4.14924 1.33334 4.33334C1.33334 4.51744 1.48258 4.66667 1.66667 4.66667H4.86194L4.09764 5.43097C3.96747 5.56114 3.96747 5.77221 4.09764 5.90237C4.22781 6.03254 4.43887 6.03254 4.56904 5.90237L5.90237 4.56904C6.03254 4.43887 6.03254 4.22781 5.90237 4.09764Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.6d3813ab336ab6da50185130fcb99eab.svg";
export { ForwardRef as ReactComponent };